module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-187.ffad613.woff2";